// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonDraftProfile_wrapper__3iWsw","nav":"SkeletonDraftProfile_nav__PAXky","content":"SkeletonDraftProfile_content__Jb3FW","item1":"SkeletonDraftProfile_item1__Fgfaz"};